module.exports = __webpack_public_path__ + "images/bannerFR-cbb9bcf56c612f61559945968d15c264.png";